var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 19.636",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.636,9.818H3.273a1.091,1.091,0,0,0-.127,2.175L3.273,12H7.636a1.091,1.091,0,0,0,0-2.182ZM18.545,7.636a1.091,1.091,0,0,0-1.09,1.091V9.818H16.364a1.091,1.091,0,0,0,0,2.182h1.091v1.091a1.091,1.091,0,1,0,2.181,0V12h1.091a1.091,1.091,0,0,0,0-2.182H19.636V8.727A1.091,1.091,0,0,0,18.545,7.636ZM6.545,0,7.636,2.182h8.728L17.455,0h2.181l1.091,2.182h1.091A2.189,2.189,0,0,1,24,4.364V17.455a2.188,2.188,0,0,1-2.182,2.181H2.182A2.188,2.188,0,0,1,0,17.455V4.364A2.189,2.189,0,0,1,2.182,2.182H3.273L4.364,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/Start.f740f715fae58983c189cc45ccb8e887.svg";
export { ForwardRef as ReactComponent };